export default __webpack_public_path__ + "static/media/cancel.d45859e2.png";